module.exports = __webpack_public_path__ + "static/img/icon_move.2344e95.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/icon/icon_move.png
// module id = F1dm
// module chunks = 2